<template lang="html">

  <section class="banner-quienes-somos row-center ais">

    <article class="left column-center">
      <div class="banner-wrapper">
        <h2>¿Quiénes somos?</h2>
        <p>Somos 75.000 familias de agricultores y ganaderos que comercializamos nuestras producciones conjuntamente a
          través de la primera cooperativa agroalimentaria del sur de Europa, porque la unión hace la fuerza.</p>
      </div>      
    </article>

    <article class="right column-center">
      <h2>La unión hace la fuerza</h2>
      <p>Este blog es un espacio abierto de comunicación en el que podrás consultar informaciones de interés del mundo agrícola y ganadero. Te ofrecemos entradas de elaboración propia y noticias de terceros que resultan de interés. Queremos hacernos eco de todos aquellos temas de actualidad relacionados con el sector agroalimentario que puedan ser de interés para los hombres y mujeres del campo.</p>
    </article>

    

  </section>

</template>

<script lang="js">
  export default {
    name: 'banner-quienes-somos',
  }
</script>


// WEBPACK FOOTER //
// src/components/parts/banner-quienes-somos.vue